import React, { useEffect, useState } from "react";
import classes from "./NotificationMobile.module.css";
import { Container, Col, Row } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { NotificationBox } from "../../../stories/NotificationBox/NotificationBox";
import { MobileFilter } from "../../../stories/MobileFilter/MobileFilter";
import {
  NotificationAnnouncementIcon,
  doubleTickBlueIcon,
  bookingIconGray,
  HomeIconGray,
  messageIconGray,
  NotificationIconGray,
  ProfileIconGray,
  CheckSymbolBlue,
  singleTickBlueIcon,
} from "../../../constant/imagePath";
import { LinkButtonWithIcon } from "../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { useHistory, useLocation } from "react-router";
import MobileBottomTab from "../../../stories/MobileBottomTab/MobileBottomTab";
import { PaginationComponent } from "../../../stories/Pagination/Pagination";
import { SendFeedbackModal } from "../../../components/Modals/CoachFlow/Notifications/SendFeedback/SendFeedback";
import { ReportProblemModal } from "../../../components/Modals/CoachFlow/Notifications/ReportProblem/ReportProblem";
import CancelLesson from "../../../components/Modals/CoachFlow/Notifications/CancelLesson/CancelLesson";
import { ReviewModal } from "../../../components/Modals/CoachFlow/Notifications/Review/Review";

export const NotificationMobile = () => {
  const staticData = [
    {
      title: "Announcement",
      type: "announcement",
      description: "Added new sports and the ability to complain about users.",
      isSeen: true,
      status: "send-feedback",
    },
    {
      title: "Training report",
      description:
        "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
      isSeen: true,
      type: "training-report",
      status: "",
    },
    {
      title: "1-on-1 Tennis Lesson",
      description: "with Ed Collins on Jul 20",
      isSeen: true,
      type: "training-request",
      status: "cancel-lesson",
      date: "July 17,2021",
    },
    {
      title: "Profile onboarding",
      description: "Your onboarding has been approved.",
      isSeen: true,
      type: "profile-update",
      status: "approved",
    },
    {
      title: "Profile onboarding",
      description:
        "Your onboarding has been declined. Since onboarding check wasn’t approved - your account remains private.",
      isSeen: true,
      type: "profile-update",
      status: "declined",
      date: "July 14, 2021",
    },
    {
      title: "Profile banned",
      description:
        "You canceled classes three times less than 24 hours before the start. Unfortunately, we are forced to ban your profile for 2 weeks. After this period, you can use our application as before.",
      isSeen: true,
      type: "profile-update",
      status: "profile-banned",
    },
    {
      title: "Profile unbanned",
      description:
        "Profile unbanned: Congratulations, your profile is active and you can book your lessons again!",
      isSeen: true,
      type: "profile-update",
      status: "profile-unbanned",
    },
    // ,
    // {
    //   title: "lesson-booked",
    //   description:
    //     "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
    //   isSeen: true,
    //   type: "lesson-booked",
    // },
    // {
    //   title: "lesson-cancelled",
    //   description:
    //     "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
    //   isSeen: true,
    //   type: "lesson-cancelled",
    // },
  ];

  const [notificationdata, setNotificationdata] = useState(staticData);
  const history = useHistory();
  const [menuItem, setMenuItem] = useState("notifications");
  const [paginatedData, setpaginatedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [readAll, setReadAll] = useState(false);

  const [isShowModalType, setIsShowModalType] = useState("");
  const [isOpenModal, setIsOpenModal] = useState("");

  const [filtervalue, setFiltervalue] = useState("Show all");
  const mobileFilters = [
    "Show all",
    "Announcement",
    "Training report",
    "Profile update",
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const pagelimit = 6;

  useEffect(() => {
    setpaginatedData(() => {
      const startIndex = currentPage * pagelimit - pagelimit;
      const endIndex = startIndex + pagelimit;
      return filteredData?.slice(startIndex, endIndex);
    });
  }, [currentPage, filteredData]);

  // For Filter Data
  function filterData() {
    let filterType = filtervalue.split(" ").join("-").toLocaleLowerCase();
    if (filterType == "show-all") {
      setFilteredData(notificationdata);
    } else {
      let newArr = [];
      notificationdata?.map((item) => {
        filterType == item?.type && newArr.push(item);
      });

      setFilteredData(newArr);
    }
  }

  useEffect(() => {
    filterData();
  }, [filtervalue]);

  return (
    <div className={[classes.NotificationScreen].join(" ")}>
      <Container fluid className={["p-0", classes.container].join(" ")}>
        <div className={[classes.headingWithBtn, classes.mb16].join(" ")}>
          <h3
            style={{
              ...Fonts.h3,
              color: Colors.neutralShadesOfNero,
              fontSize: "24px",
              lineHeight: "32px",
            }}
          >
            Notifications
          </h3>
          <LinkButtonWithIcon
            text="Mark all as read"
            primary={true}
            customStyle={{ ...Fonts.b2, lineHeight: "20px" }}
            iconStyle={{ marginRight: "10px" }}
            leftIcon={readAll ? doubleTickBlueIcon : singleTickBlueIcon}
            onClick={() => setReadAll(true)}
          />
        </div>

        <MobileFilter
          filters={mobileFilters}
          state={filtervalue}
          setter={setFiltervalue}
        />
        <Row className={["g-0", classes.row, classes.pb64].join(" ")}>
          {paginatedData?.map((item, i) => {
            return (
              <Col sm={12} key={i}>
                <NotificationBox
                  data={item}
                  onClick1={(type, status) => {
                    setIsShowModalType(type);
                    setIsOpenModal(status);
                    if (status == "go-to-onboarding")
                      history.push("/on-boarding");
                    if (status == "contact-us") history.push("/contact-us");
                    if (status == "chat") history.push("/chat");
                  }}
                  onClick2={(type, status) => {
                    setIsShowModalType(type);
                    setIsOpenModal(status);
                    if (status == "contact-us") history.push("/contact-us");
                  }}
                />
              </Col>
            );
          })}

          <Col sm={12} className={classes.lastCol}>
            <PaginationComponent
              totalPages={Math.ceil(filteredData.length / pagelimit)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </Col>
        </Row>
      </Container>

      {/*  */}
      {isShowModalType == "announcement" && (
        <>
          <SendFeedbackModal
            show={isOpenModal == "send-feedback" && true}
            setShow={() => setIsOpenModal("")}
            // to show step count in heading
            // steps="1 out of 3"
            title="Tell us about your experience with Kate"
            detailsLabel="Share your feedback about the lesson"
          />
        </>
      )}
      {/* {isShowModalType == "training-report" && ( */}
      {/* <> */}
      <ReportProblemModal
        type="message-from-admin"
        show={isOpenModal == "report" && true}
        setShow={() => setIsOpenModal("")}
      />
      <ReviewModal
        title="Tell us about your experience with John"
        show={isOpenModal == "leave-review" && true}
        setShow={() => setIsOpenModal("")}
      />
      {/* </> */}
      {/* )} */}

      {isShowModalType == "training-request" && (
        <>
          <CancelLesson
            show={isOpenModal == "cancel-lesson" && true}
            setShow={() => setIsOpenModal("")}
          />
        </>
      )}

      {/*  */}

      {/* All this modals should be displayed inside notificationBox component  */}
      {/* <SendFeedbackModal
              show={true}
              title="We would be grateful for your feedback. This way we can get better."
              detailsLabel="Share your feedback about the lesson"
            /> */}
      {/* <SuccessFeedbackModal
              show={true} 
              title="Thank you!"
              description="You review was successfully sent."
            /> */}
      {/* <ReportProblemModal show={true} /> */}
      {/* <MobileReview
        show={true}
        title="Tell us about your experience with John"
      /> */}

      <div className={classes.BottomTab}>
        <MobileBottomTab state={menuItem}
        />
      </div>
    </div>
  );
};
